module.exports = __webpack_public_path__ + "static/media/leaderEnterpriseFall2020.5d02e630.png";